import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";

export const useLanguage = () => {
    const { language } = useSelector((x:RootState)=> x.common);
   
    return {
        language
    };
}
